import React from 'react';
import TopRowTitle from '../TopRowTitle';
import { Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import YesOrNoFormField from '@rd-web-markets/shared/dist/util/form_fields/YesOrNoFormField';
import { makeKey } from '@rd-web-markets/shared/dist/hooks/useConvertForTranslationKey';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import { DecimalFormFieldRow, IntegerFormFieldRow } from '@rd-web-markets/shared/dist/util/form';
const INTEGER_FIELDS = ['iihrde_corresponds_by_head', 'iihrde_proportion_of_gross_wages_with_wage_tax', 'iihrde_gs_received_by_employees_before_28_03_2024', 'iihrde_gs_received_by_employees_after_27_03_2024', 'iihrde_proportion_of_gross_wages_no_wage_tax', 'iihrde_pgs_not_before_28_03_2024', 'iihrde_pgs_in_after_27_03_2024', 'iihrde_prorota_expenditure', 'iihrde_prorota_expenditure_before_28_03_2024', 'iihrde_prorota_expenditure_after_27_03_2024', 'iihrde_gs_received_by_employees_not_in_20_26', 'iihrde_gs_received_by_employees_in_20_26', 'iihrde_pgs_not_in_20_26', 'iihrde_pgs_in_20_26', 'iihrde_prorota_expenditure_not_in_20_26', 'iihrde_prorota_expenditure_in_20_26', 'iihrde_gross_salary', 'less_expenditure_other_funding_claimed_before_2020', 'less_expenditure_other_funding_claimed_after_2020', 'less_expenditure_other_funding_claimed_before_2024', 'less_expenditure_other_funding_claimed_after_2024', 'ocsp_working_hours', 'ocsp_working_hours_not_in_20_26', 'ocsp_working_hours_in_20_26', 'ocsp_working_hours_before_28_03_2024', 'ocsp_working_hours_after_27_03_2024'];
const DECIMAL_FIELDS = ['iihrde_number_of_times_associated', 'ic_prop_carried_in_affiliated_companies', 'b1_sum_wages_own_employees_before', 'calc_eligible_expenses_wages_own_employees_1_version_7', 'calc_eligible_expenses_wages_own_employees_1_version_8', 'd1_sum_wages_own_employees_after', 'calc_eligible_expenses_wages_own_employees_2_version_7', 'calc_eligible_expenses_wages_own_employees_2_version_8', 'ic_prop_carried_in_taxexempt_inst', 'ic_prop_carried_in_other_taxable_companies'];
const FIELDS_WITHOUT_OVERLAY = ['iihrde_corresponds_by_head', 'iihrde_proportion_of_gross_wages_with_wage_tax', 'iihrde_gs_received_by_employees_before_28_03_2024', 'iihrde_gs_received_by_employees_after_27_03_2024', 'iihrde_proportion_of_gross_wages_no_wage_tax', 'iihrde_pgs_not_before_28_03_2024', 'iihrde_pgs_in_after_27_03_2024', 'iihrde_prorota_expenditure', 'iihrde_prorota_expenditure_before_28_03_2024', 'iihrde_prorota_expenditure_after_27_03_2024'];
const shouldIndentFields = ['iihrde_gs_received_by_employees_in_20_26', 'iihrde_gross_salary', 'iihrde_gs_received_by_employees_not_in_20_26', 'iihrde_pgs_not_in_20_26', 'iihrde_pgs_in_20_26', 'iihrde_prorota_expenditure_not_in_20_26', 'iihrde_prorota_expenditure_in_20_26', 'ocsp_working_hours_not_in_20_26', 'ocsp_working_hours_in_20_26', 'dcr_remun_paid_not_in_20_26', 'dcr_remun_paid_in_20_26', 'dcr_remun_paid_before_28_3_24', 'dcr_remun_paid_after_27_3_24', 'ocsp_working_hours_before_28_03_2024', 'ocsp_working_hours_after_27_03_2024', 'ic_prop_carried_in_affiliated_companies', 'ic_prop_carried_in_taxexempt_inst', 'ic_prop_carried_in_other_taxable_companies'];
const YES_NO_FIELDS = ['ic_rd_project_will_carried_with_affiliated_companies', 'ic_rd_project_is_carried_with_taxexempt_research_institutions', 'ic_rd_project_will_carried_with_other_taxable_comapnies', 'ocp_research_carried_out'];
const ProjectDetailRow = _ref => {
  let {
    rowData,
    translationKey,
    index,
    updateState,
    projectDetails,
    disabled = false,
    label,
    rowClass = '',
    tooltipText = '',
    isVersion8
  } = _ref;
  const {
    t
  } = useTranslation();
  const renderInput = (field, index) => {
    if (DECIMAL_FIELDS.includes(field[0])) {
      return /*#__PURE__*/React.createElement(DecimalFormFieldRow, {
        key: field[0] + 'decimalField',
        fieldName: field[0],
        value: field[1],
        onChange: e => updateState({
          target: {
            value: e.target.value
          }
        }, projectDetails, field[0]),
        dataTestId: "project-detail-field-".concat(field[0]),
        fieldStyle: {
          width: '100px'
        },
        disabled: disabled
      });
    } else if (INTEGER_FIELDS.includes(field[0])) {
      return /*#__PURE__*/React.createElement(IntegerFormFieldRow, {
        key: field[0] + 'integerField',
        fieldName: field[0],
        value: field[1],
        onChange: e => updateState({
          target: {
            value: e.target.value
          }
        }, projectDetails, field[0]),
        dataTestId: "project-detail-field-".concat(field[0]),
        fieldStyle: {
          width: '100px'
        },
        disabled: disabled
      });
    } else if (YES_NO_FIELDS.includes(field[0])) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        key: field[0] + 'affiliateYesOrNo',
        className: "mt-3"
      }, /*#__PURE__*/React.createElement(YesOrNoFormField, {
        labelText: t(translationKey),
        md: {
          field: {
            span: 12
          }
        },
        renderLabel: false,
        formName: 'projectDetail' + index,
        checkedField: field[1],
        onChange: updateState,
        onChangeParams: [projectDetails, field[0]]
      })));
    }
  };
  const b1Title = isVersion8 ? t('determination_assessment_basis_eligible_expenses_incurred_b_2024') : t('determination_assessment_basis_eligible_expenses_incurred_b_2020');
  const d1Title = isVersion8 ? t('determination_calculating_eligible_expenditure_b_2024') : t('determination_calculating_eligible_expenditure_b_2020');
  return /*#__PURE__*/React.createElement("div", null, rowData[0] === 'iihrde_number_of_times_associated' && /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t(makeKey('Information on in-house R & D expenditure'))
  }), rowData[0] === 'ocp_research_carried_out' && /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t(makeKey('Own contribution of a sole proprietor to this R & D project'))
  }), rowData[0] === 'ic_rd_project_will_carried_with_affiliated_companies' && /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t(makeKey('Information on cooperations)'))
  }), rowData[0] === 'b1_sum_wages_own_employees_before' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t('determination_of_eligible_expenses_from_wages_title')
  }), /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t(b1Title)
  })), rowData[0] === 'd1_sum_wages_own_employees_after' && /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t(d1Title)
  }), /*#__PURE__*/React.createElement(Row, {
    className: rowClass
  }, /*#__PURE__*/React.createElement(Col, {
    md: 7
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      marginLeft: shouldIndentFields.includes(rowData[0]) ? '4rem' : '2rem'
    }
  }, label || t(translationKey))), /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, !!tooltipText.length && !FIELDS_WITHOUT_OVERLAY.includes(rowData[0]) ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "top",
    overlay: /*#__PURE__*/React.createElement(Tooltip, null, tooltipText)
  }, /*#__PURE__*/React.createElement("div", null, renderInput(rowData, index))) : renderInput(rowData, index)), /*#__PURE__*/React.createElement("hr", null)));
};
export default ProjectDetailRow;